const modals = {
  Text: 'TextModal',
  Dialog: 'DialogModal',
  HeroAdd: 'HeroAddModal',
  HeroView: 'HeroViewModal',
  Content: 'ContentModal',
  Editable: 'EditableModal',
  DialogWithSelect: 'DialogWithSelectModal',
  DialogWithForm: 'DialogWithFormModal',
  DialogWithFormTable: 'DialogWithFormTableModal',
  Report: 'ReportModal',

  AddCatalog: 'AddCatalogModal',

  // voting
  Vote: 'VoteModal',
}


export default modals
